import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { requestErrorHandler } from "utils";
import { RestoreCarrierActions } from "store/ducks/settings/carriers";

export function* restoreCarrierRequest(action: any) {
  try {
    const { id, onSuccess } = action;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/carriers/${id}/restore`
    );

    const { data } = responseBody;
    yield put(RestoreCarrierActions.success(data));
    notify("success", "Transportadora restaurada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(RestoreCarrierActions.failure(errorMessage));
  }
}